import { useEffect, useState, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export interface MyReview {
  id: string;
  rating: number;
  review_text: string;
  display_name: string;
  display_role: string | null;
  photo_url: string | null;
  status: "pending" | "approved" | "rejected";
  created_at: string;
}

export function useMyReview() {
  const { user } = useAuth();
  const [review, setReview] = useState<MyReview | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!user) {
      setReview(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    const { data } = await supabase
      .from("reviews")
      .select("id, rating, review_text, display_name, display_role, photo_url, status, created_at")
      .eq("user_id", user.id)
      .maybeSingle();
    setReview((data as MyReview) ?? null);
    setLoading(false);
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { review, loading, refresh };
}
